import styles from './../AuthPage.module.scss';
import {loginByUserName} from '../../../api/auth';
import {useNavigate} from 'react-router-dom';
import {useMemo, useState} from 'react';

const Login = () => {
    const navigate = useNavigate();

    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const canSubmit = useMemo(() => {
        return username.trim().length > 0 && password.length > 0 && !loading;
    }, [username, password, loading]);

    async function performLogin(event: React.FormEvent) {
        event.preventDefault();
        setError(null);
        setLoading(true);

        try {
            await loginByUserName(username.trim(), password);
            navigate('/lobby');
        } catch (e: any) {
            setError('Login failed. Check username/password and try again.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className={styles.auth}>
            <div className={styles.auth__card}>
                <div className={styles.auth__brand}>
                    <div>
                        <h1 className={styles.auth__title}>Low Five</h1>
                        <div className={styles.auth__subtitle}>Sign in to continue</div>
                    </div>
                </div>

                {error && <div className={styles.auth__error}>{error}</div>}

                <form className={styles.auth__form} onSubmit={performLogin}>
                    <div className={styles.auth__field}>
                        <label className={styles.auth__label} htmlFor="username">Username</label>
                        <input
                            id="username"
                            className={styles.auth__input}
                            name="username"
                            autoComplete="username"
                            placeholder="Your username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>

                    <div className={styles.auth__field}>
                        <label className={styles.auth__label} htmlFor="password">Password</label>
                        <input
                            id="password"
                            className={styles.auth__input}
                            name="password"
                            type="password"
                            autoComplete="current-password"
                            placeholder="Your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    <button className={styles.auth__primaryBtn} type="submit" disabled={!canSubmit}>
                        {loading ? 'Logging in…' : 'Login'}
                    </button>
                </form>

                <button className={styles.auth__secondaryBtn} onClick={() => navigate('/signup')}>
                    Create Account Instead
                </button>

                <div className={styles.auth__footer}>
                    Tip: usernames are case-sensitive
                </div>
            </div>
        </div>
    );
};

export default Login;
